<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2>{{ $t('navigations.device controllers') }}</h2>
        </div>
    </div>
    <div class="wrapper wrapper-content">
        <div class="ibox-content mb-1 px-3 py-2">
            <div class="form-group row mb-0 my-lg-0">
                <div
                    class="
                        d-flex
                        flex-column flex-lg-row
                        justify-content-lg-start
                        my-2 my-lg-0
                        mb-lg-0
                    "
                >
                    <div class="col-lg-3 my-1 pl-lg-0 pr-lg-1">
                        <div class="form-group mb-md-0">
                            <label class="mb-0">{{ $t('navigations.user') }}</label>
                            <input
                                type="text"
                                class="form-control my-md-2 my-lg-0"
                                v-model="searchName"
                               
                            />
                        </div>
                    </div>
                    <div class="col-lg-4 my-1 pl-lg-0 pr-lg-1">
                        <div class="form-group mb-md-0">
                            <label class="mb-0">{{ $t('navigations.email') }}</label>
                            <input
                                type="text"
                                class="form-control my-md-2 my-lg-0"
                                v-model="searchText"
                               
                            />
                        </div>
                    </div>
                     <div class="col-lg-3 my-1 pl-lg-0 pr-lg-1">
                        <div class="form-group mb-md-0">
                            <label class="mb-0">{{ $t('navigations.device name') }}</label>
                            <input
                                type="text"
                                class="form-control my-md-2 my-lg-0"
                                v-model="searchDeviceName"
                            />
                        </div>
                    </div>
                    <div class="col-12 col-lg-2 my-1 align-self-end">
                        <span
                            type="button"
                            class="save_btn w-100"
                            @click.prevent="search"
                        >
                            {{ $t('navigations.search') }}
                        </span>
                    </div>
                </div>
         
            </div>
        </div>
        <div class="ibox-body">
            <div class="ibox-title style_2">
                <h5>{{ $t('navigations.device controllers') }}</h5>
            </div>
            <div class="ibox-content">
                <div class="text-center" v-if="showLoading === true">
                <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class=""
                    alt="Waiting for login"
                />
                <div>
                    {{ $t("navigations.please wait while the list is being loaded") }}
                </div>
                </div>    
                <template v-else>
                    <div class="text-center" v-if="deviceList.length==0">
                        {{ $t('navigations.no data available') }}
                    </div>                    
                    <div class="table-responsive" v-else>
                        <table class="table table-striped table-bordered dataTables">
                            <thead>
                                <tr>
                                    <th
                                        class="sort_block"
                                        @click="SortSelected('user', 1)"
                                        id="1"
                                    >                  
                                        <div class="d-flex flex-row justify-content-between">    
                                            {{ $t('navigations.user') }}     
                                            <span>
                                                <i class="fa fa-long-arrow-up"></i>
                                                <i class="fa fa-long-arrow-down"></i>
                                            </span>
                                        </div>
                                    </th>
                                    <th
                                        class="sort_block"
                                        @click="SortSelected('email', 2)"
                                        id="2"
                                    >                  
                                        <div class="d-flex flex-row justify-content-between">    
                                            {{ $t('navigations.email') }}     
                                            <span>
                                                <i class="fa fa-long-arrow-up"></i>
                                                <i class="fa fa-long-arrow-down"></i>
                                            </span>
                                        </div>
                                    </th>
                                    <th
                                        class="sort_block"
                                        @click="SortSelected('deviceName', 3)"
                                        id="3"
                                    >                  
                                        <div class="d-flex flex-row justify-content-between">    
                                            {{ $t('navigations.device name') }}     
                                            <span>
                                                <i class="fa fa-long-arrow-up"></i>
                                                <i class="fa fa-long-arrow-down"></i>
                                            </span>
                                        </div>
                                    </th>
                                    <th
                                        class="sort_block"
                                        @click="SortSelected('deviceId', 4)"
                                        id="4"
                                    >                  
                                        <div class="d-flex flex-row justify-content-between">    
                                            {{ $t('navigations.device id') }}     
                                            <span>
                                                <i class="fa fa-long-arrow-up"></i>
                                                <i class="fa fa-long-arrow-down"></i>
                                            </span>
                                        </div>
                                    </th>
                                    <th
                                        class="sort_block"
                                        @click="SortSelected('dateTime', 5)"
                                        id="5"
                                    >                  
                                        <div class="d-flex flex-row justify-content-between">    
                                            {{ $t('navigations.date & time') }}     
                                            <span>
                                                <i class="fa fa-long-arrow-up"></i>
                                                <i class="fa fa-long-arrow-down"></i>
                                            </span>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(device,index) in deviceList" :key="device.deviceId+device.email+index">
                                    <td>{{ device.userName }}</td>
                                    <td>{{ device.email }}</td>
                                    <td>{{ device.deviceName }}</td>
                                    <td>{{ device.deviceId }}</td>
                                    <td>
                                        <span v-if="device.dateTime && device.dateTime !== '0001-01-01T00:00:00Z'">
                                            {{ filter(device.dateTime) }}&nbsp;&nbsp;{{ toTime(device.dateTime) }}
                                        </span>
                                    </td>
                                </tr>
                                <tr v-if="deviceList.length === 0">
                                    <td colspan="5" class="text-center">{{ $t('navigations.no data found') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!------ pagination -------->
                    <div class="row mx-0" v-if="deviceList.length!=0">
                            <div class="col-lg-12 mx-0 px-0">
                                <div
                                    class="
                                        dataTables_paginate
                                        paging_simple_numbers
                                        pagination
                                        float-right
                                    "
                                >
                                    <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                                        <v-pagination
                                            v-model="currentPageNumber"
                                            :pages="totalPages"
                                            :range-size="0"
                                            active-color="#618bd7"
                                            @update:modelValue="loadPage"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script src="./device_controllers.js"></script>

<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
.form-group {
    margin-bottom: 0 !important;
}
.create-block {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0.25rem;
}
.form-select {
    border-radius: 0 !important;
}
.form-select:focus {
    border-color: #145faf !important;
    box-shadow: 0 0 0 !important;
}

.cursor-pointer {
    cursor: pointer;
}
.position-relative {
    position: relative;
}
.position-relative .tool-tip {
    visibility: hidden;
    width: max-content;
    background-color: #616161;
    color: #fff;
    text-align: center;
    border-radius: 0.3em;
    padding: 0.1rem 0.8rem;
    right: 0;
    top: -30px;
    font-size: 0.8rem;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    -webkit-transition: visibility 75ms ease-in;
    transition: visibility 75ms ease-in;
}
.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
    visibility: visible;
    -webkit-transition: visibility 30ms ease-in;
    transition: visibility 30ms ease-in;
}
.scrollable3 {
    overflow-y: scroll;
    height: 250px;
}
.audit__details__modal__wrapper {
    position: fixed;
    inset: 0;
    background: rgb(0 0 0 / 18%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    z-index: 3000;
}
.audit__details__modal__container {
    width: min(90%, 365px);
    position: fixed;
    background: rgb(255, 255, 255);
    border-radius: 4px;
    overflow-y: hidden;
}
.audit__details__modal__title,
.audit__history__modal__title {
    background-color: var(--pop-up-background);
    color: #ffffff;
}
.audit__details__modal__content {
    overflow-y: scroll;
    height: 250px;
}
.audit__history__modal__contents {
    overflow-y: scroll;
    height: 404px;
}
.audit__history__modal__wrapper {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    z-index: 4000;
}
.audit__history__modal__container {
    width: min(45%, 90%);
    position: fixed;
    background: rgb(255, 255, 255);
    border-radius: 4px;
    overflow-y: hidden;
}
</style>
